module.exports = {
	"mainBrandColor": "#2aac8e",
	"selectedColor": "#22272b",
	"logoUrl": "branding/logo.svg",
	"logoExternal": false,
	"darkUICharts": true,
	"fonts": {
		"main": "#ffffff",
		"button": "#ffffff",
		"header": "#ffffff",
		"panelHeader": "#ffffff"
	},
	"backgrounds": {
		"main": "#171b1d",
		"menu": "#374148",
		"inputs": "#374148",
		"header": "#2b3237",
		"panel": "#2b3237",
		"panelHeader": "#374148",
		"panelSecondary": "#374148"
	},
	"footerElements": [
		{
			"type": "i",
			"props": {
				"className": "fa fa-copyright",
				"key": "copyright-icon"
			},
			"content": ""
		},
		{
			"type": "span",
			"props": {
				"key": "copyright-text"
			},
			"content": "{YEAR} Scality. All rights reserved."
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/branding/branding.json
 ** module id = 28
 ** module chunks = 0
 **/